import { lazyWithRetry } from 'Core/lazyWithRetry'

export { clearBridgeCookies, resumeURL, takeBack } from './utils'

// Lazy so App's eager import of this barrel does not pull in the page and the redux store.
export const SamlBridge = lazyWithRetry(() =>
  import('./SamlBridge').then((m) => ({ default: m.SamlBridge }))
)
